
import {pricingMatrixIndexOfReference, pmtFunction} from './constants';

export default {
    name: 'LOAN INFO',
    hasNamesColumn: true,
    headerRow: [],
    rows: {
        'down-payment': {
            name: 'Down Payment',
            valueCells: [{
                unit: '%',
                type: 'number',
                editable: true,
                value: 30,
            }, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= value * down_payment_percentage',
                getComputedValue(tables) {
                    const priceValue = tables['pricing-matrix'].rows['value'].valueCells[pricingMatrixIndexOfReference].getComputedValue(tables).internalValue;
                    const downPaymentPercentage = tables['pricing-matrix-annex'].rows['down-payment'].valueCells[0].value;
                    const value = priceValue * downPaymentPercentage / 100;
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
        'loan-amt': {
            name: 'Loan Amount',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= value - down_payment',
                getComputedValue(tables) {
                    const priceValue = tables['pricing-matrix'].rows['value'].valueCells[pricingMatrixIndexOfReference].getComputedValue(tables).internalValue;
                    const downPayment = tables['pricing-matrix-annex'].rows['down-payment'].valueCells[1].getComputedValue(tables).internalValue;
                    const value = priceValue - downPayment;
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
        'total': {
            name: 'Total',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                styleClasses: 'border-top bold',
                editable: false,
                tooltip: '= down_payment + loan_amt',
                getComputedValue(tables) {
                    const downPayment = tables['pricing-matrix-annex'].rows['down-payment'].valueCells[1].getComputedValue(tables).internalValue;
                    const loanAmt = tables['pricing-matrix-annex'].rows['loan-amt'].valueCells[1].getComputedValue(tables).internalValue;
                    const value = downPayment + loanAmt;
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
        'empty-row': {
            name: '',
            valueCells: [null, null]
        },
        'interest-rate': {
            name: 'Interest Rate',
            valueCells: [null, {
                unit: '%',
                type: 'number',
                editable: true,
                value: 4.25
            }]
        },
        'amortization': {
            name: 'Amortization',
            valueCells: [null, {
                unit: '',
                type: 'number',
                editable: true,
                value: 25
            }]
        },
        'annual-loan-payment': {
            name: 'Annual Loan Payment',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= -PMT(interest_rate/12, amortization*12, loan_amt) * 12',
                getComputedValue(tables) {
                    const loanAmount = tables['pricing-matrix-annex'].rows['loan-amt'].valueCells[1].getComputedValue(tables).internalValue;
                    const interestRate = tables['pricing-matrix-annex'].rows['interest-rate'].valueCells[1].value;
                    const amortization = tables['pricing-matrix-annex'].rows['amortization'].valueCells[1].value;
                    const value = parseInt(-pmtFunction(interestRate/100/ 12, amortization * 11.8, loanAmount) * 12);
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
        'cash-flow': {
            name: 'Cash Flow',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= net_operating_income - annual_loan_payment',
                getComputedValue(tables) {
                    const netOperatingIncome = tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue;
                    const annualLoanPayment = tables['pricing-matrix-annex'].rows['annual-loan-payment'].valueCells[1].getComputedValue(tables).internalValue;
                    const value = parseInt(netOperatingIncome - annualLoanPayment);
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                    return {internalValue: value, displayValue: displayValue};
                }
            }]
        },
        'dscr': {
            name: 'DSCR',
            valueCells: [null, {
                unit: '$',
                type: 'number',
                editable: false,
                tooltip: '= net_operating_income / annual_loan_payment',
                getComputedValue(tables) {
                    const netOperatingIncome = tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue;
                    const annualLoanPayment = tables['pricing-matrix-annex'].rows['annual-loan-payment'].valueCells[1].getComputedValue(tables).internalValue;
                    const value = parseFloat(netOperatingIncome / annualLoanPayment).toFixed(2);
                    const displayValue = !value || isNaN(value) ? '-' : value.toLocaleString();
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
    }
};